import { Button } from "@mui/material";
import styles from "./LoginButton.module.css";
import { isLoggedIn, login, logout } from "../../authConfig";

type LoginButtonProps = {
    loginButtonMessage?: string;
    size?: "small" | "medium" | "large";
};

export const LoginButton = ({ loginButtonMessage, size }: LoginButtonProps) => {
    // BFF: login/logout are backend redirects/requests. No browser token cache.
    const loggedIn = isLoggedIn();

    const handleLogin = () => {
        login();
    };

    const handleLogout = () => {
        logout().catch(error => console.log(error));
    };

    return (
        <Button
            {...(size ? { size } : {})}
            className={styles.loginButton}
            variant="contained"
            onClick={loggedIn ? handleLogout : handleLogin}
        >
            {loggedIn ? "Logout" : loginButtonMessage ?? "Login"}
        </Button>
    );
};
